import React from 'react';
import { OrderInfo, OrderInfoDelivery } from 'common/types';
import RentalCardDeliveryTime from './RentalCardDeliveryTime';
import RentalCardCarrierInfo from './RentalCardCarrierInfo';
import RentalCardReturnTime from './RentalCardReturnTime';
import { getRentalDeliveryEndTime } from 'common/utils/dateCalculations';
import { useTranslation } from 'services/localization/useTranslation';
import { SELF_RETURN_CARRIER } from 'common/modules/delivery/constants';

interface Props {
	rentalInfo: OrderInfo;
	delivery?: OrderInfoDelivery | undefined;
}
const ActiveRentalCardStatus = (props: Props) => {
	const { rentalInfo, delivery } = props;
	const { t } = useTranslation();

	return delivery?.from ? (
		<>
			<RentalCardDeliveryTime
				deliveryDate={getRentalDeliveryEndTime(rentalInfo)}
				spacing="normal"
				informationText={t('rentalCard.pickupSlot', 'Returned at the latest')}
			/>
			{delivery.from?.carrierId && delivery.from?.carrierId !== SELF_RETURN_CARRIER.id && (
				<RentalCardCarrierInfo carrierId={delivery.from.carrierId} />
			)}
		</>
	) : (
		<RentalCardReturnTime startDate={rentalInfo.startDate} returnTime={rentalInfo.returnTimeNext} />
	);
};

export default ActiveRentalCardStatus;
